import { isFactory as fetchFactoryVisible } from '@/api/homeApi';

let factoryVisiblePromise = null;

export function getFactoryVisible() {
  if (!factoryVisiblePromise) {
    factoryVisiblePromise = fetchFactoryVisible()
      .then((res) => res?.data === true)
      .catch((error) => {
        factoryVisiblePromise = null;
        throw error;
      });
  }

  return factoryVisiblePromise;
}

export function resetFactoryVisibleCache() {
  factoryVisiblePromise = null;
}
